import React, { useRef, useCallback, useEffect, useMount } from 'react';
import cn from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { markRead } from '@/models/conversations/actions';
import { message } from 'antd';
//import HorizontalTimeline from 'react-horizontal-timeline';
import EditorBox from './Editor';
import MessageList from './List';
import styles from './styles.module.less';
import 'antd/dist/antd.css';
export default function MessageBox({ className, orderId, convId, isFold, onChat }) {
  const dispatch = useDispatch();
  const [curIdx, setCurIdx] = React.useState(0);
  const [prevIdx, setPrevIdx] = React.useState(-1);
  const handleMarkRead = useCallback(() => dispatch(markRead(convId)), [
    convId,
  ]);
  useEffect(() => {
    if (convId) {
      handleMarkRead();
      const $msgBox = document.getElementById('msg-box');
      $msgBox.addEventListener('click', handleMarkRead);
      return () => {
        $msgBox.removeEventListener('click', handleMarkRead);
      };
    }
  }, [convId]);

  if (!convId) {
    return (
      <div className={cn(styles.messageBox, styles.emptyTips)}>
        <img src={process.env.PUBLIC_URL + '/illustration-10.svg'}></img>
        <p className={styles.emptyTipsText}>
          请在左侧 <b>会话栏</b> 中选择工单
        </p>
      </div>
    );
  }

  return (
    <div id="msg-box" className={styles.messageBox}>
      <MessageList orderId={orderId} onChat={onChat} />
      <EditorBox convId={convId} orderId={isFold ? orderId : ''} />
    </div>
  );
}
